function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6176 15.0861C21.6176 15.1386 21.596 15.2211 21.4916 15.3377C21.3852 15.4567 21.2104 15.5897 20.9538 15.7284C20.441 16.0055 19.6737 16.267 18.693 16.4912C16.7377 16.9381 14.0177 17.218 11 17.218C7.98233 17.218 5.26226 16.9381 3.30702 16.4912C2.32633 16.267 1.55903 16.0055 1.04621 15.7284C0.789563 15.5897 0.614802 15.4567 0.508353 15.3377C0.403967 15.2211 0.382353 15.1386 0.382353 15.0861C0.382353 15.0335 0.403967 14.951 0.508353 14.8344C0.614802 14.7155 0.789563 14.5825 1.04621 14.4438C1.55903 14.1666 2.32633 13.9051 3.30702 13.6809C5.26226 13.234 7.98233 12.9541 11 12.9541C14.0177 12.9541 16.7377 13.234 18.693 13.6809C19.6737 13.9051 20.441 14.1666 20.9538 14.4438C21.2104 14.5825 21.3852 14.7155 21.4916 14.8344C21.596 14.951 21.6176 15.0335 21.6176 15.0861Z",
  fill: "#E8E7FF",
  stroke: "black",
  strokeWidth: 0.764706
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 19.486,
  rx: 11,
  ry: 2.51429,
  fill: "#E8E7FF"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 15.0859,
  width: 6.06897,
  height: 4.4,
  fill: "#E8E7FF"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 15.931,
  y: 15.0859,
  width: 6.06897,
  height: 4.4,
  fill: "#E8E7FF"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 15.0861,
  rx: 11,
  ry: 2.51429,
  fill: "#E8E7FF"
});

var _ref7 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 12,
  width: 22,
  height: 6
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 15.0861,
  rx: 11,
  ry: 2.51429,
  fill: "#928DB5"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.4,
  filter: "url(#filter0_f)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.7586,
  cy: 14.4572,
  rx: 12.5172,
  ry: 2.51429,
  fill: "#88859C"
})));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6176 8.79993C21.6176 8.85248 21.596 8.93501 21.4916 9.05161C21.3852 9.17052 21.2104 9.30353 20.9538 9.44223C20.441 9.71935 19.6737 9.9809 18.693 10.2051C16.7377 10.652 14.0177 10.9319 11 10.9319C7.98233 10.9319 5.26226 10.652 3.30702 10.2051C2.32633 9.9809 1.55903 9.71935 1.04621 9.44223C0.789563 9.30353 0.614802 9.17052 0.508353 9.05161C0.403967 8.93501 0.382353 8.85248 0.382353 8.79993C0.382353 8.74738 0.403967 8.66485 0.508353 8.54825C0.614802 8.42934 0.789563 8.29633 1.04621 8.15763C1.55903 7.88051 2.32633 7.61896 3.30702 7.3948C5.26226 6.94789 7.98233 6.668 11 6.668C14.0177 6.668 16.7377 6.94789 18.693 7.3948C19.6737 7.61896 20.441 7.88051 20.9538 8.15763C21.2104 8.29633 21.3852 8.42934 21.4916 8.54825C21.596 8.66485 21.6176 8.74738 21.6176 8.79993Z",
  fill: "#E8E7FF",
  stroke: "black",
  strokeWidth: 0.764706
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 13.1998,
  rx: 11,
  ry: 2.51429,
  fill: "#E8E7FF"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  y: 8.7998,
  width: 6.06897,
  height: 4.4,
  fill: "#E8E7FF"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 15.931,
  y: 8.7998,
  width: 6.06897,
  height: 4.4,
  fill: "#E8E7FF"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 8.79993,
  rx: 11,
  ry: 2.51429,
  fill: "#E8E7FF"
});

var _ref14 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 6,
  width: 22,
  height: 6
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 8.79993,
  rx: 11,
  ry: 2.51429,
  fill: "#928DB5"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.4,
  filter: "url(#filter1_f)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.7586,
  cy: 8.17102,
  rx: 12.5172,
  ry: 2.51429,
  fill: "#88859C"
})));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6176 2.51429C21.6176 2.56684 21.596 2.64937 21.4916 2.76597C21.3852 2.88487 21.2104 3.01789 20.9538 3.15658C20.441 3.43371 19.6737 3.69526 18.693 3.91941C16.7377 4.36632 14.0177 4.64622 11 4.64622C7.98233 4.64622 5.26226 4.36632 3.30702 3.91941C2.32633 3.69526 1.55903 3.43371 1.04621 3.15658C0.789563 3.01789 0.614802 2.88487 0.508353 2.76597C0.403967 2.64937 0.382353 2.56684 0.382353 2.51429C0.382353 2.46174 0.403967 2.3792 0.508353 2.2626C0.614802 2.1437 0.789563 2.01069 1.04621 1.87199C1.55903 1.59486 2.32633 1.33332 3.30702 1.10916C5.26226 0.662247 7.98233 0.382353 11 0.382353C14.0177 0.382353 16.7377 0.662247 18.693 1.10916C19.6737 1.33332 20.441 1.59486 20.9538 1.87199C21.2104 2.01069 21.3852 2.1437 21.4916 2.2626C21.596 2.3792 21.6176 2.46174 21.6176 2.51429Z",
  fill: "#E8E7FF",
  stroke: "black",
  strokeWidth: 0.764706
});

var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 6.91419,
  rx: 11,
  ry: 2.51429,
  fill: "#E8E7FF"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  y: 2.51416,
  width: 6.06897,
  height: 4.4,
  fill: "#E8E7FF"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 15.931,
  y: 2.51416,
  width: 6.06897,
  height: 4.4,
  fill: "#E8E7FF"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 2.51429,
  rx: 11,
  ry: 2.51429,
  fill: "#DFDDF3"
});

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f",
  x: -3.81749,
  y: 8.88405,
  width: 31.1521,
  height: 11.1462,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.52941,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f",
  x: -3.81749,
  y: 2.59791,
  width: 31.1521,
  height: 11.1462,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.52941,
  result: "effect1_foregroundBlur"
})));

var SvgSql = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSql, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sql.c2b5c8be.svg";
export { ForwardRef as ReactComponent };